<template>
  <div class="food-manage">
    <!-- <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form class="fn-clear">
          <el-form-item label="渠道" class="fn-left">
            <Select key="5" :selected.sync="listQuery.channel_id" :data="channelLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="手机" class="fn-left">
            <el-input v-model="listQuery.mobile" placeholder="请输入手机号" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-checkbox v-model="listQuery.tll_status" true-label="20062018214508001072" false-label="">只看已无效的例子</el-checkbox>
          </el-form-item>
          <el-form-item label="" class="fn-left" />
        </el-form>
      </div>
    </div> -->
    <div class="tuolele-main-box">
      <el-button type="success" style="margin-bottom: 20px;" @click="fnUpdate()">新增</el-button>

      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="ID" prop="id" align="center" />
        <el-table-column label="说明" prop="content" align="center" />

        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button size="small" type="success" @click="fnUpdate(row)">编辑</el-button>
            <el-button size="small" type="danger" @click="fnDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="listQuery.limit" @current-change="fnGetPenaltyList" />
    </div> -->
    <el-dialog
      title="编辑"
      :visible.sync="dialogVisible1"
    >
      <el-form ref="form1" :model="setPostForm" label-width="100px" :rules="rules">
        <el-form-item label="说明" prop="content">
          <el-input v-model="setPostForm.content" type="textarea" />
        </el-form-item>
        <el-form-item label="积分" prop="score">
          <el-input-number v-model="setPostForm.score" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fnSubmitUpdate">提交</el-button>
      </div>
    </el-dialog>
  </div>

</template>
<script>

// import Select from '@/components/Select'

import { validateRequire } from '@/utils/validate'
// import Tool from '@/assets/js/tool.js'
const defaultSetBonusPenaltySubmitPostForm = {
  id: '',
  content: '',
  score: '0'
}
export default {
  name: 'TurnStudentList',
  components: {
    // Select
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      setPostForm: Object.assign({}, defaultSetBonusPenaltySubmitPostForm),
      dialogVisible1: false,
      total: 0,
      listQuery: {
        p: 1,
        limit: 20
      },
      rules: {
        content: [{ required: true, trigger: 'manual', message: '请输入说明' }],
        score: [{ validator: (rule, value, callback) => {
          if (value == 0) {
            callback(new Error('请填写积分'))
          } else {
            callback()
          }
        }, trigger: 'manual', required: true }]
      }

    }
  },
  created() {
    this.fnGetPenaltyList()
  },
  methods: {
    fnGetPenaltyList: function() {
      this.$http.getBonusPenaltyList(this.listQuery).then(res => {
        this.lists = res.data
        // this.total = parseInt(res.data.count)
      })
    },
    fnUpdate(row) {
      // this.$router.push({ path: '/pointRewardPunishmentsEdit', query: { id: row.id }})
      this.setPostForm = Object.assign({}, defaultSetBonusPenaltySubmitPostForm)
      if (row) {
        this.setPostForm = Object.assign({}, row)
      }
      this.dialogVisible1 = true
    },
    fnSubmitUpdate() {
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          this.$http.bonusPenaltySubmit(this.setPostForm).then(res => {
            if (res.code == 200) {
              this.$message({ type: 'success', message: '操作成功!' })
              this.dialogVisible1 = false
              this.fnGetPenaltyList()
            }
          })
        }
      })
    },
    fnDelete(row) {
      this.$confirm(`确认删除内容为<${row.content}>的记录吗？`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        this.$http.bonusPenaltyRemove({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message({ type: 'success', message: '操作成功!' })
            this.fnGetPenaltyList()
          }
        })
      })
    },
    changeTime: function(val) {
      if (val != null) {
        this.listQuery.begin_time = val[0]
        this.listQuery.end_time = val[1]
      } else {
        this.listQuery.begin_time = ''
        this.listQuery.end_time = ''
        this.listQuery.time = []
      }
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
